export default (theme) => ({
    modalContent: {},
    htmlPreview: {
        minHeight: 200,
        padding: 16,
        backgroundColor: theme.colors.primary.white,
        borderRadius: 4,
        border: `1px solid ${theme.colors.grey[100]}`,
    },
});
